import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { IconInitializerProvider } from '@securly/ui-components/core-components/icon';

import { routes } from './app.routes';
import { storeConfig } from './core/store/store.config';
import { AppInitService } from './core/services/app-init.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    IconInitializerProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () => appInitService.initializeApp(),
      deps: [AppInitService],
      multi: true
    },
    ...storeConfig,
  ]
};
